import { withFeatureBranch } from '../redux/flags';
import { CommentableTypes } from '../Comment/types';
import CommentThread from './CommentThread';
import CommentThreadV2 from './CommentThreadV2';
import CommentThreadContainer from './CommentThread.container';
import * as actions from './actionCreators';
import * as selectors from './selectors';
export default withFeatureBranch({
    comment_v2: CommentThreadContainer(CommentThreadV2),
})(CommentThreadContainer(CommentThread));
export { actions, selectors, CommentableTypes };
export { THREAD_MAX_DEPTH, THREAD_MAX_DEPTH_MOBILE } from './constants';
//# sourceMappingURL=index.js.map